export const capitalize = (str: string) => {
  return str && str.charAt(0).toUpperCase() + str.slice(1);
};

export const getLineBreaksStyle = (str: string | undefined): string => {
  if (str) {
    const words = str.split(" ");
    return words.length > 1 ? "break-word" : "break-all";
  }
  return "break-all";
};

export const replaceURLsWithLinks = (str: string) => {
  const urlRegex = /((https?:\/\/|www\.)\S+)/g;
  return str.replace(urlRegex, "<a href='$1' target='_blank' style='text-decoration: underline;'>$1</a>",
  );
};
